var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft, faEdit, faHdd, faSitemap, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BButtonGroup } from "bootstrap-vue";
import { computed, ref } from "vue";
import { RouterLink } from "vue-router";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import { copyWorkflow } from "../Workflow/workflows.services";
import AsyncButton from "../Common/AsyncButton.vue";
import Heading from "../Common/Heading.vue";
import SwitchToHistoryLink from "../History/SwitchToHistoryLink.vue";
import UtcDate from "../UtcDate.vue";
import WorkflowInvocationsCount from "../Workflow/WorkflowInvocationsCount.vue";
import WorkflowRunButton from "../Workflow/WorkflowRunButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationHeader',
    props: {
        invocation: null,
        fromPanel: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { workflow } = useWorkflowInstance(props.invocation.workflow_id);
        const userStore = useUserStore();
        const owned = computed(() => {
            if (userStore.currentUser && workflow.value) {
                return userStore.currentUser.username === workflow.value.owner;
            }
            else {
                return false;
            }
        });
        const importErrorMessage = ref(null);
        const importedWorkflow = ref(null);
        function onImport() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!workflow.value || !workflow.value.owner) {
                    return;
                }
                try {
                    const wf = yield copyWorkflow(workflow.value.id, workflow.value.owner);
                    importedWorkflow.value = wf;
                }
                catch (error) {
                    importErrorMessage.value = errorMessageAsString(error, "Failed to import workflow");
                }
            });
        }
        function getWorkflowName() {
            var _a;
            return ((_a = workflow.value) === null || _a === void 0 ? void 0 : _a.name) || "...";
        }
        return { __sfc: true, props, workflow, userStore, owned, importErrorMessage, importedWorkflow, onImport, getWorkflowName, faClock, faArrowLeft, faEdit, faHdd, faSitemap, faUpload, FontAwesomeIcon, BAlert, BButton, BButtonGroup, RouterLink, localize, AsyncButton, Heading, SwitchToHistoryLink, UtcDate, WorkflowInvocationsCount, WorkflowRunButton };
    }
});
